export const secondForm = {
  pt: {

    // --- Labels do Formulário ---
    direitoArrependimentoQuestion: 'Direito de arrependimento',
    direitoArrependimentoText:
      'Marque "Sim" se você tentou cancelar ou modificar sua compra dentro de 7 dias após a aquisição e teve dificuldades com a empresa. Se não tentou ou não teve problemas desta natureza, marque "Não".',

    descumprimentoOfertaQuestion: 'Descumprimento de oferta',
    descumprimentoOfertaText:
      'Marque "Sim" se a empresa não entregou o produto que foi comprado. Por exemplo, se você comprou uma passagem para a classe executiva e foi colocado na classe econômica. Se recebeu exatamente o que comprou, marque "Não".',

    extravioDefinitivoQuestion: 'Extravio definitivo de bagagem',
    extravioDefinitivoText:
      'Marque "Sim" se sua bagagem foi perdida e nunca mais encontrada. Caso tenha sido devolvida em algum momento, marque "Não".',

    extravioTemporarioQuestion: 'Extravio temporário de bagagem e tempo decorrido',
    extravioTemporarioText:
      'Se sua bagagem foi perdida, mas depois devolvida, marque a opção que indica o tempo que demorou para ser recuperada. Se não houve bagagem perdida, marque "Não houve extravio".',
    
    violacaoBagagemQuestion: 'Violação de bagagem',
    violacaoBagagemText:
      'Marque "Sim" se sua bagagem foi aberta sem sua permissão, se foi danificada ou se teve itens furtados. Se não houveram problemas desta natureza, marque "Não".',

    hipervulnerabilidadeQuestion: 'Hipervulnerabilidade',
    hipervulnerabilidadeText:
      'Marque "Sim" se você é idoso, gestante, possui deficiência, usa medicamentos ou estava viajando com uma criança menor de 12 anos. Caso contrário, marque "Não".',

    atrasoCancelamentoQuestion: 'Atraso, cancelamento e alteração de voo',
    atrasoChegadaText:
      'Se você chegou ao destino final, mas com atraso, marque a opção que indica o tempo decorrido entre o horário previsto para chegar ao destino final e o horário que você efetivamente chegou.',
    atrasoDestinoAlteradoText:
      'Se você não chegou ao destino final ou foi enviado para outro local, marque "Não cheguei em meu destino final ou tive o meu destino final alterado".',
    atrasoSemProblemasText:
      'Se não houve atrasos, cancelamentos ou alterações, marque "Não houve problemas".',

    noshowQuestion: 'No show',
    noshowText:
      'Marque "Sim" se a companhia cancelou automaticamente seu voo de volta porque você não compareceu ao voo de ida, sem que você tenha concordado com isso. Se isso não aconteceu, marque "Não".',

    overbookingQuestion: 'Overbooking',
    overbookingText:
      'Marque "Sim" se você não conseguiu embarcar porque a empresa vendeu mais passagens do que o número de assentos disponíveis. Caso tenha conseguido embarcar normalmente, marque "Não".',

    sim: 'Sim',
    nao: 'Não',

    falhaAssistenciaQuestion: 'Falha na assistência da companhia aérea:',
    falhaAssistenciaTitle: 'Marque "Sim" se você enfrentou problemas com seu voo e a companhia aérea:',
    falhaAssistenciaNaoPrestou: 'Não prestou assistência (como alimentação, hospedagem ou transporte alternativo).',
    falhaAssistenciaTardiamente: 'Prestou assistência, porém tardiamente.',
    falhaAssistenciaInsuficiente: 'Prestou assistência, porém insuficiente para a sua necessidade.',
    falhaAssistenciaNao: 'Marque "Não" se a companhia ofereceu suporte adequado, garantindo alimentação, hospedagem, transporte alternativo ou qualquer outra assistência conforme sua necessidade.',

    // --- Opções de Intervalo (Faixa de tempo) ---
    naoHouveExtravio: 'Não houve extravio',
    acima169h: 'Acima de 169h',
    acima28h: 'Acima de 28h',
    naoHouveProblemas: 'Não houve problemas',
    naoChegueiDestino: 'Não cheguei em meu destino final ou tive o meu destino final alterado',

    // --- Textos de Rodapé, Botões e Mensagens ---
    consultar: 'Consultar',
    predictionTitle: 'Previsão de danos morais:',
    requestError: 'Não foi possível realizar a requisição, verifique se o formulário foi devidamente preenchido e tente novamente.',
    
    // Checkbox e Modal
    declaracaoCiente: 'Declaro estar ciente dos termos da ferramenta Concil-IA.',
    verDetalhes: 'Ver detalhes',
    termosTitle: 'Termos da Ferramenta Concil-IA',
    modeloCienteTitle: 'Declaro estar ciente que o modelo:',
    termoInformativo: 'Está em fase inicial de desenvolvimento, sendo os resultados fornecidos meramente informativos e não vinculativos, ou seja, não substituem a análise individual do caso pelo(a) magistrado(a) do órgão competente.',
    termoInesperado: 'Pode apresentar comportamentos inesperados, especialmente em situações com combinações raras de fatores, para as quais há poucos dados de comparação no histórico de treinamento do modelo.',
    termoTreinamento: 'Foi treinado com base em decisões judiciais disponíveis até 22/05/2024. Portanto, eventuais mudanças no entendimento do juízo local ou de instâncias superiores após essa data não estão refletidas nas predições geradas.',
    fechar: 'Fechar',

    // SHAP Explanation
    fatoresInfluenciaTitle: 'Fatores que influenciaram o valor estimado',
    fatoresInfluenciaText1: 'Este gráfico mostra como cada informação do caso impactou a previsão do valor de dano moral, em relação à média das previsões do modelo.',
    fatoresInfluenciaText2Blue: ['Azul', ': indica que o fator contribuiu para reduzir o valor estimado.'],
    fatoresInfluenciaText2Red: ['Vermelho', ': indica que o fator contribuiu para aumentar esse valor.'],
    fatoresInfluenciaText3: 'É possível visualizar, por exemplo, o peso de elementos como tempo de atraso, ausência de assistência ou perda de conexão na estimativa final.',
    fatoresInfluenciaText4: ['A explicação foi gerada com o apoio da técnica ', 'SHAP', ', sigla para ', 'SHapley Additive exPlanations ', '(Explicações Aditivas de Shapley), que permite compreender a influência individual de cada variável na previsão.'],
    fatoresInfluenciaText5: 'Para mais informações sobre a técnica SHAP, consulte a documentação oficial: ',
  },
  en: {
    
    // --- Form Labels ---
    direitoArrependimentoQuestion: 'Right to Regret',
    direitoArrependimentoText:
      'Mark "Yes" if you attempted to cancel or modify your purchase within 7 days of acquisition and experienced difficulties with the company. If you did not attempt to, or had no problems of this nature, mark "No".',

    descumprimentoOfertaQuestion: 'Breach of Offer (Downgrade)',
    descumprimentoOfertaText:
      'Mark "Yes" if the company failed to deliver the product that was purchased. For example, if you bought a business class ticket and were placed in economy class. If you received exactly what you purchased, mark "No".',

    extravioDefinitivoQuestion: 'Permanent Baggage Loss',
    extravioDefinitivoText:
      'Mark "Yes" if your baggage was lost and never found. If it was returned at some point, mark "No".',

    extravioTemporarioQuestion: 'Temporary Baggage Loss and Duration',
    extravioTemporarioText:
      'If your baggage was lost but later returned, select the option indicating the time it took to be recovered. If no baggage was lost, select "No loss occurred".',
    
    violacaoBagagemQuestion: 'Tampered Baggage',
    violacaoBagagemText:
      'Mark "Yes" if your baggage was opened without your permission, if it was damaged, or if items were stolen. If there were no problems of this nature, mark "No".',

    hipervulnerabilidadeQuestion: 'Hypervulnerability',
    hipervulnerabilidadeText:
      'Mark "Yes" if you are elderly, pregnant, have a disability, use medication, or were traveling with a child under 12 years old. Otherwise, mark "No".',

    atrasoCancelamentoQuestion: 'Delay, Cancellation, and Flight Change',
    atrasoChegadaText:
      'If you arrived at the final destination, but with a delay, select the option indicating the time elapsed between the scheduled arrival time at the final destination and the time you actually arrived.',
    atrasoDestinoAlteradoText:
      'If you did not reach the final destination or were sent to another location, select "I did not reach my final destination or my final destination was changed".',
    atrasoSemProblemasText:
      'If there were no delays, cancellations, or changes, select "No problems occurred".',

    noshowQuestion: 'No Show',
    noshowText:
      'Mark "Yes" if the company automatically canceled your return flight because you failed to board the outbound flight, without your agreement. If this did not happen, mark "No".',

    overbookingQuestion: 'Overbooking',
    overbookingText:
      'Mark "Yes" if you were unable to board because the company sold more tickets than the number of available seats. If you were able to board normally, mark "No".',

    sim: 'Yes',
    nao: 'No',

    falhaAssistenciaQuestion: 'Failure of Airline Assistance:',
    falhaAssistenciaTitle: 'Mark "Yes" if you faced problems with your flight and the airline:',
    falhaAssistenciaNaoPrestou: 'Did not provide assistance (such as food, accommodation, or alternative transportation).',
    falhaAssistenciaTardiamente: 'Provided assistance, but with a delay.',
    falhaAssistenciaInsuficiente: 'Provided assistance, but it was insufficient for your needs.',
    falhaAssistenciaNao: 'Mark "No" if the company offered adequate support, ensuring food, accommodation, alternative transportation, or any other assistance as needed.',

    // --- Time Range Options ---
    naoHouveExtravio: 'No loss occurred',
    acima169h: 'Over 169h',
    acima28h: 'Over 28h',
    naoHouveProblemas: 'No problems occurred',
    naoChegueiDestino: 'I did not reach my final destination or my final destination was changed',

    // --- Footer Texts, Buttons, and Messages ---
    consultar: 'Consult',
    predictionTitle: 'Prediction of moral damages:',
    requestError: 'The request could not be processed. Please verify that the form was properly filled out and try again.',

    // Checkbox and Modal
    declaracaoCiente: 'I declare that I am aware of the usage terms of the Concil-IA tool.',
    verDetalhes: 'View details',
    termosTitle: 'Terms of the Concil-IA Tool',
    modeloCienteTitle: 'I declare that I am aware that the model:',
    termoInformativo: 'Is in its initial phase of development, and the results provided are merely informative and non-binding, meaning they do not replace the individual case analysis by the magistrate of the competent body.',
    termoInesperado: 'May exhibit unexpected behavior, especially in situations with rare combinations of factors, for which there is little comparison data in the model\'s training history.',
    termoTreinamento: 'Was trained based on judicial decisions available up to 05/22/2024. Therefore, any changes in the understanding of the local court or higher instances after this date are not reflected in the generated predictions.',
    fechar: 'Close',

    // SHAP Explanation
    fatoresInfluenciaTitle: 'Factors that influenced the estimated value',
    fatoresInfluenciaText1: 'This graph shows how each piece of case information impacted the prediction of the moral damage value, relative to the average of the model\'s predictions.',
    fatoresInfluenciaText2Blue: ['Blue', ': indicates that the factor contributed to reducing the estimated value.'],
    fatoresInfluenciaText2Red: ['Red', ': indicates that the factor contributed to increasing this value.'],
    fatoresInfluenciaText3: 'It is possible to visualize, for example, the weight of elements such as delay time, absence of assistance, or missed connection in the final estimate.',
    fatoresInfluenciaText4: ['The explanation was generated with the support of the ', 'SHAP' , ' technique, an acronym for ', 'SHapley Additive exPlanations ', '(Explicações Aditivas de Shapley), which allows understanding the individual influence of each variable on the prediction.'],
    fatoresInfluenciaText5: 'For more information about the SHAP technique, consult the official documentation: ',
  },
};